import { Headphones, UserCheck, Megaphone } from "lucide-react";

const cards = [
  {
    title: "White-glove Onboarding",
    desc: "Work with our team to streamline launch — pages, channels, reminders, the works.",
    gradient: "from-orange-200 via-rose-200 to-blue-200",
    Icon: Megaphone,
  },
  {
    title: "Dedicated CSM",
    desc: "Boost adoption with a People Ops expert who plans every campaign with you.",
    gradient: "from-purple-300 via-fuchsia-300 to-blue-300",
    Icon: UserCheck,
  },
  {
    title: "Flexible Support",
    desc: "Escalate critical questions to our priority team — day or night, weekdays or weekends.",
    gradient: "from-teal-200 via-cyan-200 to-blue-200",
    Icon: Headphones,
  },
];

export const SupportCards = () => (
  <section className="container mx-auto px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-24">
    <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12">
      <h2 className="text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-tight">
        The Easiest Way To Run<br className="hidden sm:block" /> A Listening Program
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
      {cards.map(({ title, desc, gradient, Icon }) => (
        <div
          key={title}
          className="bg-card border border-border rounded-3xl p-3 mkt-shadow-card overflow-hidden"
        >
          <div className={`h-32 sm:h-44 rounded-2xl bg-gradient-to-br ${gradient} relative overflow-hidden flex items-center justify-center`}>
            <div className="absolute inset-0 bg-white/10" />
            <div className="relative h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-white/30 backdrop-blur-md inline-flex items-center justify-center text-white">
              <Icon className="h-6 w-6 sm:h-7 sm:w-7" />
            </div>
          </div>
          <div className="p-4 sm:p-5">
            <h3 className="text-base sm:text-lg font-bold text-foreground">{title}</h3>
            <p className="mt-1.5 sm:mt-2 text-[13px] sm:text-sm text-muted-foreground leading-relaxed">{desc}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
